<script>
import appConfig from "@/app.config"
import Consulta from "./consulta.vue";

/**
 * Wallets component
 */
export default {
  page: {
    title: "Consultas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      consultas: [],
      buscando: false,
      title: "Consultas",
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Master",
          href: "#",
        },
        {
          text: "Consultas",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      this.buscando = true;
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/master/query_repositories", { headers: this.$headers })
        .then((response) => {
          this.consultas = response.data;
        })
        .catch((error) => this.$axiosCatch(error))
        .finally(() => this.buscando = false);
    },
  },
  components: { Consulta }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div role="tablist">
            <Consulta :consultas="consultas" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>